<header>
  <div class="header-container">
    <img *ngIf="brokerId == '01'" width="190px" src="../../../../../assets/images/chill-logo.svg" alt="Chill Logo"
      (click)="redirectToPortal()" />
    <img *ngIf="brokerId == '04'" [src]="'../assets/images/devil-logo.png' " width="190px" alt="Quote Devil logo"
      (click)="redirectToPortal()" [ngClass]="{'qd': brokerId == '04'}">
    <div class="quote-reference-container" [hidden]="!quoteReference">
      <span class="title" *ngIf="quoteReference.length > 2">Quote Reference: </span><span
        class="quote-reference">{{quoteReference}}</span>
    </div>
  </div>
</header>